/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_List_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Speaker list" |
*
* @param {Speaker_Manager_List_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_list_aria_label = /** @type {((inputs?: Speaker_Manager_List_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_List_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Liste des locuteurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprecherliste")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elenco degli oratori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Список докладчиков")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lista de oradores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("演讲者名单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("講演者リスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वक्ताओं की सूची")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Lista de oradores")
	return /** @type {LocalizedString} */ ("Speaker list")
});